module.exports = JSON.parse("{\"paths\":[],\"buildDate\":\"2026-10-24T21:10:46.146Z\"}")